import { render } from "./DeviceModeBadge.vue?vue&type=template&id=3f49bc4c"
import script from "./DeviceModeBadge.vue?vue&type=script&lang=js"
export * from "./DeviceModeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__